import { render, staticRenderFns } from "./itemCustomFields.vue?vue&type=template&id=1fd42ab8&scoped=true&"
import script from "./itemCustomFields.vue?vue&type=script&lang=js&"
export * from "./itemCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd42ab8",
  null
  
)

export default component.exports